<template>
  <div></div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState(["userInfo"]),
    type() {
      return this.$route.query.type;
    }
  },
  created() {
    // 1：术韵 2：星光
    if(this.type == 2) {
      if(this.$route.query.otherId && this.$route.query.userId && this.$route.query.userId != this.$route.query.otherId) {
        this.$router.replace({ path: '/xgPersonal', query: { otherId: this.$route.query.otherId } });
      } else {
        if(this.userInfo.Type == 2) {
          this.$router.replace("/xgJNJPersonal");
        } else {
          this.$router.replace("/xgPersonal");
        }
      }
      // if(this.userInfo.Type == 2) {
      //   if(this.$route.query.otherId) {
      //     this.$router.replace({ path: '/xgJNJPersonal', query: { otherId: this.$route.query.otherId } })
      //   } else {
      //     this.$router.replace("/xgJNJPersonal");
      //   }
      // } else {
      //   if(this.$route.query.otherId) {
      //     this.$router.replace({ path: '/xgPersonal', query: { otherId: this.$route.query.otherId } });
      //   } else {
      //     this.$router.replace("/xgPersonal");
      //   }
      // }
    } else {
      if(this.$route.query.otherId && this.$route.query.userId && this.$route.query.userId != this.$route.query.otherId) {
        this.$router.replace({ path: '/Personal', query: { otherId: this.$route.query.otherId } });
      } else {
        if(this.userInfo.Type == 2) {
          this.$router.replace("/JNJPersonal");
        } else {
          this.$router.replace("/Personal");
        }
      }
      // if(this.userInfo.Type == 2) {
      //   if(this.$route.query.otherId) {
      //     this.$router.replace({ path: '/JNJPersonal', query: { otherId: this.$route.query.otherId } });
      //   } else {
      //     this.$router.replace("/JNJPersonal");
      //   }
      // } else {
      //   if(this.$route.query.otherId) {
      //     this.$router.replace({ path: '/Personal', query: { otherId: this.$route.query.otherId } });
      //   } else {
      //     this.$router.replace("/Personal");
      //   }
      // }
    }
  }
}
</script>